import { bl_fi_my_einvoice_tin_update_request_line_RowClass } from "../../dbschema";
import { BaseContainerModel } from "../base-container.model";

export class MyEInvoiceTinUpdateRequestLineContainerModel extends BaseContainerModel {
    bl_fi_my_einvoice_tin_update_request_line: bl_fi_my_einvoice_tin_update_request_line_RowClass = new bl_fi_my_einvoice_tin_update_request_line_RowClass();
}